var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var template = "\n  <transition :name=\"$effect\" mode=\"out-in\">\n    <div v-if=\"view === 0\" :key=\"0\" class=\"await-default\" ref=\"defaultRef\">\n      <slot></slot>\n    </div>\n\n    <div v-else-if=\"view === 1\" :key=\"1\" class=\"await-spinner\" :style=\"{minHeight}\">\n      <component\n        v-if=\"$spinner && $spinner !== 'none' && !hasLoadingSlot\"\n        :is=\"$spinner\"\n        :color=\"$spinnerColor\"\n        :style=\"{padding: $spinnerPadding, zoom: $spinnerScale}\"\n      />\n      <slot name=\"loading\" v-else></slot>\n    </div>\n\n    <div v-else-if=\"view === 2\" :key=\"2\" class=\"await-error\">\n      <slot name=\"error\"></slot>\n    </div>\n  </transition>\n";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { sleep } from '../../helpers/index';
import { $ } from '../../simpli';
export var View;
(function (View) {
    View[View["DEFAULT"] = 0] = "DEFAULT";
    View[View["LOADING"] = 1] = "LOADING";
    View[View["ERROR"] = 2] = "ERROR";
})(View || (View = {}));
export var Event = new Vue();
var AwaitController = /** @class */ (function () {
    function AwaitController() {
        this.defaultTransition = null;
        this.defaultSpinner = null;
        this.defaultSpinnerColor = '#42b983';
        this.defaultSpinnerPadding = '10px';
        this.defaultSpinnerScale = 1;
        this.loaders = {};
    }
    AwaitController.prototype.addLoader = function (name, component) {
        var _a;
        this.loaders = Object.assign(this.loaders, (_a = {}, _a[name] = component, _a));
    };
    AwaitController.prototype.init = function (name) {
        Event.$emit('toggle', name, View.LOADING);
    };
    AwaitController.prototype.done = function (name) {
        Event.$emit('toggle', name, View.DEFAULT);
    };
    AwaitController.prototype.error = function (name) {
        Event.$emit('toggle', name, View.ERROR);
    };
    AwaitController.prototype.run = function (func, name, delay) {
        return __awaiter(this, void 0, void 0, function () {
            var result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        this.init(name);
                        if (!delay) return [3 /*break*/, 2];
                        return [4 /*yield*/, sleep(delay)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, func()];
                    case 3:
                        result = _a.sent();
                        this.done(name);
                        return [2 /*return*/, result];
                    case 4:
                        e_1 = _a.sent();
                        this.error(name);
                        throw e_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return AwaitController;
}());
export { AwaitController };
var Await = /** @class */ (function (_super) {
    __extends(Await, _super);
    function Await() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.$effect = null;
        _this.$spinner = null;
        _this.$spinnerColor = null;
        _this.$spinnerPadding = null;
        _this.$spinnerScale = null;
        _this.view = View.DEFAULT;
        return _this;
    }
    Object.defineProperty(Await.prototype, "hasLoadingSlot", {
        get: function () {
            return this.$slots.hasOwnProperty('loading');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Await.prototype, "hasErrorSlot", {
        get: function () {
            return this.$slots.hasOwnProperty('error');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Await.prototype, "minHeight", {
        get: function () {
            return this.height + "px" || 'unset';
        },
        enumerable: true,
        configurable: true
    });
    Await.prototype.mounted = function () {
        if (this.$refs.defaultRef)
            this.height = this.$refs.defaultRef.offsetHeight;
    };
    Await.prototype.beforeMount = function () {
        var _this = this;
        if (this.init)
            this.view = View.LOADING;
        this.$effect = this.effect || $.await.defaultTransition;
        this.$spinner = this.spinner || $.await.defaultSpinner;
        this.$spinnerColor = this.spinnerColor || $.await.defaultSpinnerColor;
        this.$spinnerPadding = this.spinnerPadding || $.await.defaultSpinnerPadding;
        this.$spinnerScale = this.spinnerScale || $.await.defaultSpinnerScale;
        this.$options.components = Object.assign(this.$options.components, $.await.loaders);
        Event.$on('toggle', function (name, view) {
            if (view === void 0) { view = View.DEFAULT; }
            if (name === _this.name) {
                if (view === View.ERROR && !_this.hasErrorSlot) {
                    _this.view = View.DEFAULT;
                }
                else {
                    _this.view = view;
                }
                switch (view) {
                    case View.LOADING:
                        _this.$emit('loading');
                        break;
                    case View.ERROR:
                        _this.$emit('error');
                        break;
                }
            }
        });
    };
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Await.prototype, "name", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Await.prototype, "effect", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Await.prototype, "spinner", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Await.prototype, "spinnerColor", void 0);
    __decorate([
        Prop({ type: String }),
        __metadata("design:type", String)
    ], Await.prototype, "spinnerPadding", void 0);
    __decorate([
        Prop({ type: Number }),
        __metadata("design:type", Number)
    ], Await.prototype, "spinnerScale", void 0);
    __decorate([
        Prop({ type: Boolean }),
        __metadata("design:type", Boolean)
    ], Await.prototype, "init", void 0);
    Await = __decorate([
        Component({ template: template })
    ], Await);
    return Await;
}(Vue));
export { Await };
//# sourceMappingURL=Await.js.map